import type { Novidade } from './tipos';

/** Ficha 2026-11-03 (editar e atraso): editar o evento criado no Google e receber as mudanças de lá mais rápido. */
export const novidadeGoogleEditar: Novidade = {
  id: '2026-11-03-google-editar',
  publicada_em: '2026-11-03',
  tipo: 'melhoria',
  modulo: 'agenda',
  permissao: 'agenda.criar',
  textos: {
    pt: {
      titulo: 'Edite aqui o que criou no Google Agenda',
      resumo: 'O evento criado no Google Agenda agora abre no MalgoOS para editar, e as mudanças feitas lá chegam mais rápido.',
      passos: [
        'Com o seu Google conectado em Minha conta > Perfil, clique no evento em CRM > Reuniões/Agenda.',
        'Altere o que precisar e salve. O evento continua o mesmo no Google, sem duplicar, e passa a aparecer com o título para quem vê a Agenda.',
        'Evento em que você é só convidado fica para consulta: quem muda é quem organiza. No evento repetido, a mudança vale só para aquela ocorrência.',
      ],
    },
    en: {
      titulo: 'Edit here what you created in Google Calendar',
      resumo: 'An event created in Google Calendar now opens in MalgoOS for editing, and changes made there arrive faster.',
      passos: [
        'With your Google connected in My account > Profile, click the event in CRM > Meetings/Calendar.',
        'Change what you need and save. The event stays the same in Google, with no duplicate, and now shows its title to whoever sees the Calendar.',
        'An event where you are only a guest is read-only: the organizer makes the changes. On a repeating event, the change applies only to that occurrence.',
      ],
    },
    es: {
      titulo: 'Edita aquí lo que creaste en Google Calendar',
      resumo: 'El evento creado en Google Calendar ahora se abre en MalgoOS para editar, y los cambios hechos allí llegan más rápido.',
      passos: [
        'Con tu Google conectado en Mi cuenta > Perfil, haz clic en el evento en CRM > Reuniones/Agenda.',
        'Cambia lo que necesites y guarda. El evento sigue siendo el mismo en Google, sin duplicar, y pasa a mostrar el título a quien ve la Agenda.',
        'Un evento en el que solo eres invitado queda para consulta: quien lo cambia es quien organiza. En un evento repetido, el cambio vale solo para esa ocurrencia.',
      ],
    },
  },
  treinamento: { curso: 'novidades' },
  imagens: ['/novidades/2026-11-03-google-editar/formulario.webp', null, null, null],
  rota: '/crm/reunioes',
};
